export default __webpack_public_path__ + "static/media/august2024-2.de548497.jpg";